import {Link, Navigate, useNavigate} from "react-router-dom";
import React, {useContext, useEffect, useState} from "react";
import { HeaderLogo } from "../components/headerLogoComponent";
import { NavigationBar } from "../components/NavigationBar";
import '../../styles/mainpage.css';
import CacheExtension from "../../StarterKit/Filter/CacheExtension";
import HelperService from "../Services/Bll/HelperService";
import AppService from "../Services/Bll/AppService";
import { FilterPanel } from "../components/FilterPanelComponent";

import { PieChartCustom } from "../components/charts/PieChartCustom"
import { BarChartCustom } from "../components/charts/BarChartCustom"
import { BasicIndicator } from "../components/charts/BasicIndicator"
import {mockDataBar1, mockDataBar2, mockDataBarDest2, mockDataDest2} from "../data/mockPieDataBar";
import {motion as m} from "framer-motion"
import {LineChartCustom} from "../components/charts/LineChartCustom";
import {mockDataLine} from "../data/mockDataLine";
import FilterPanelProvider from "../Provider/FilterPanelProvider";
import {ViewContext} from "../Context/ViewContext";
import KpiService from "../Services/Bll/KpiService";

import {createTheme, useMediaQuery} from "@mui/material";
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import {ArrowDropDownIcon} from "@mui/x-date-pickers";
import LoaderComponent from "../components/LoaderComponent";

export default function AchatsPage() {
    const {loader, showLoader, hideLoader} = useContext(ViewContext);
    const [data, setData] = useState(null);
    const service = new AppService();

    const [kpi, setKpi] = useState(null);
    const navigate = useNavigate()
    const logged = HelperService.isLogged()
    const [loadingPage, setLoadingPage] = useState(null);

    const kpiService = new KpiService();

    const theme = createTheme({
        breakpoints: {
            values: {
                xs: 0,
                sm: 600,
                md: 960,
                lg: 1280,
                xl: 1920,
            },
        },
    });
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
    useEffect(() => {
        const fetchParams = {navigate, logged, showLoader, hideLoader, setKpi, isMobile};
        kpiService.fetchData(fetchParams)
    }, [])


    const handleKpiUpdate = (newsKpi) => {
        kpiService.handleKpiUpdate(newsKpi, setKpi)
        hideLoader()
    };

    const handleLoadingPage = (loading) => {
        setLoadingPage(loading);
    }

    const viewsItem = localStorage.getItem('backclick')
    var directionAnimation = '';
    var nameclass = '';
    if (viewsItem == 1) {
        directionAnimation = '-100vw'
        nameclass = "reverseAnim"
    } else {
        directionAnimation = '100vw'
        nameclass = ""
    }

    const labels = {label: kpi?.label, labelSecond: kpi?.labelSecond};

    if (loader) return null;

    return (
        <>
            <NavigationBar/>
            <FilterPanelProvider>
                {isMobile ? (
                    <Accordion className="h-auto" sx={{backgroundColor:'#b57ee3', borderRadius: '0 !important'}}>
                        <AccordionSummary
                            sx={{color:'white'}}
                            expandIcon={<ArrowDropDownIcon/>}
                        >
                            <span style={{fontSize:'12px', fontWeight:'bold'}}>Filtre</span>
                        </AccordionSummary>
                        <AccordionDetails>
                            <FilterPanel onKpiUpdate={handleKpiUpdate} isMobile={isMobile}
                                         onLoadingPage={handleLoadingPage}/>
                        </AccordionDetails>
                    </Accordion>
                ) : (
                    <FilterPanel onKpiUpdate={handleKpiUpdate} onLoadingPage={handleLoadingPage}/>
                )}
            </FilterPanelProvider>
            <LoaderComponent loadingPage={loadingPage}/>
            {!loadingPage && (<div className={`indicContainer ${isMobile ? 'container' : ''}`}>
                <BasicIndicator data={kpi?.currentYearAchatReel} dataBis={kpi?.currentYearAchatReelSecond} />
                <BasicIndicator data={kpi?.currentYearAchatPrev} dataBis={kpi?.currentYearAchatPrevSecond} />
                {kpi?.graph1 &&
                    <LineChartCustom data={kpi?.graph1} dataBis={kpi?.graph1Second} title="Achat réels moyens par nuit par mois de départ" labels={labels} />}
                {kpi?.histo1 &&
                    <BarChartCustom data={kpi?.histo1} dataBis={kpi?.histo1Second} title="Achats réels par destination"
                                    groupMode="grouped" layout="vertical" keysArray={['N', 'N-1', 'objectif']}
                                    width="82%" left="80" fontSizeX={"9px"} labels={labels}/> }
            </div>)}
        </>
    );
}









